import { useEffect, useRef, useState } from "react";
import { Bell, PackageCheck } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import http from "../api/http";

const formatearFecha = (value) =>
  value
    ? new Date(value).toLocaleString("es-AR", { dateStyle: "short", timeStyle: "short" })
    : "-";

export default function NotificationBell() {
  const location = useLocation();
  const wrapperRef = useRef(null);
  const [abierto, setAbierto] = useState(false);
  const [notificaciones, setNotificaciones] = useState([]);
  const [cargando, setCargando] = useState(false);

  const cargar = async () => {
    try {
      setCargando(true);
      const { data } = await http.get("/notificaciones");
      setNotificaciones(Array.isArray(data) ? data : []);
    } catch {
      setNotificaciones([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargar();
    const actualizar = () => cargar();
    window.addEventListener("notificaciones:actualizar", actualizar);
    return () => window.removeEventListener("notificaciones:actualizar", actualizar);
  }, [location.pathname]);

  useEffect(() => {
    if (!abierto) return undefined;
    const cerrarAlClickearAfuera = (event) => {
      if (!wrapperRef.current?.contains(event.target)) setAbierto(false);
    };
    document.addEventListener("mousedown", cerrarAlClickearAfuera);
    return () => document.removeEventListener("mousedown", cerrarAlClickearAfuera);
  }, [abierto]);

  const alternar = () => {
    setAbierto((actual) => !actual);
    if (!abierto) cargar();
  };

  return (
    <div className="notification-bell" ref={wrapperRef}>
      <button
        type="button"
        className="notification-button"
        aria-label={`Notificaciones${notificaciones.length ? `: ${notificaciones.length} activas` : ""}`}
        aria-expanded={abierto}
        title="Notificaciones"
        onClick={alternar}
      >
        <Bell size={19} />
        {notificaciones.length > 0 && (
          <span className="notification-count">{notificaciones.length > 99 ? "99+" : notificaciones.length}</span>
        )}
      </button>

      {abierto && (
        <div className="notification-popover">
          <div className="notification-popover-head">
            <div>
              <strong>Notificaciones</strong>
              <span>{notificaciones.length} productos para reponer</span>
            </div>
            <Bell size={18} />
          </div>

          <div className="notification-recent-list">
            {cargando && notificaciones.length === 0 ? (
              <div className="notification-empty">Consultando stock...</div>
            ) : notificaciones.length === 0 ? (
              <div className="notification-empty">
                <PackageCheck size={22} />
                No hay productos bajo minimo.
              </div>
            ) : (
              notificaciones.slice(0, 5).map((item) => (
                <Link
                  className="notification-recent-item"
                  to="/notificaciones"
                  key={item.id}
                  onClick={() => setAbierto(false)}
                >
                  <strong>{item.producto}</strong>
                  <span>
                    Actual: {Number(item.stockActual || 0).toLocaleString("es-AR")} {item.unidadMedida}
                    {" · "}Minimo: {Number(item.stockMinimo || 0).toLocaleString("es-AR")} {item.unidadMedida}
                  </span>
                  <small>{formatearFecha(item.fechaNotificacion)}</small>
                </Link>
              ))
            )}
          </div>

          <Link className="notification-see-all" to="/notificaciones" onClick={() => setAbierto(false)}>
            Ver todas las notificaciones
          </Link>
        </div>
      )}
    </div>
  );
}
